import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react"
import Portal from "./portal"
import { document } from "browser-monads";
import {useLockBodyScroll, useToggle} from 'react-use';
import FocusTrap from "../../hooks/focusTrap";

//https://levelup.gitconnected.com/accessible-modals-in-gatsby-using-portals-1e80e33a8a2


const Modal = forwardRef((props, ref) => {

  const [display, setDisplay] = useState(false)

  useLockBodyScroll(display);

  useImperativeHandle(
    ref,
    () => {
      return {
        openModal: () => handleOpen(),
        closeModal: () => handleClose(),
      }
    }
  )

  const handleOpen = () => {
    setDisplay(true);
    document.getElementById('___gatsby').style.filter = "blur(10px)";
  }

  const handleClose = () => {
    setDisplay(false);
    document.getElementById('___gatsby').style.filter = "blur(0)";
  }



  if (display) {
    return (
      <Portal>
          <div 
            onClick={handleClose}
            css={{
              position: `fixed`,
              top: `0`,
              bottom: `0`,
              left: `0`,
              right: `0`,
              //filter: `blur(10px)`,
              backgroundColor: `rgba(0, 0, 0, 0.9)`,
              zIndex: `9999999`
          }}></div>
          <div css={{
            position: `fixed`,
            zIndex: `99999999`,
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
            minWidth: `10rem`,
            minHeight: `10rem`,
            
          }}>
            <div css={{position: `relative`}}>
              <div css={{
                position: `relative`,
                textAlign: `right`,
                zIndex: `99999999999999`
              }}>
                <button css={{background: `#000`, height: `40px`, width: `40px`, color: `#fff`, border: `2px solid #fff`, borderRadius: `50%`, cursor: `pointer`}} type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}><span css={{fontSize: `2.0rem`}}aria-hidden="true">&times;</span></button>
              </div>
              <div css={{padding: `0 1.25rem`, marginTop: `-1.1rem`, position: `relative`,}}>
              <div css={{border: `1px solid #000`, boxShadow: `0 3px 7px rgba(0, 0, 0, 0.3)`}}>
              {props.children}
              </div>
              </div>
            </div>
          </div>
      </Portal>
    )
  }

  return null
})

export default Modal